import React from "react"
import { SectionProps, withSection } from "@app/hoc/Section"
import { Box, Button, Container, Flex, Heading } from "@chakra-ui/react"
import Link from "@components/Link"

export type LinksProps = GatsbyTypes.SanitySectionLinks & SectionProps

const Links = ({ title, links, variant, paddingSize = 2, padding, paddingTop, paddingBottom }: LinksProps) => (
  <Box
    paddingTop={paddingTop || padding ? paddingSize : 0}
    paddingBottom={paddingBottom || padding ? paddingSize : 0}
    marginTop={paddingTop || padding ? paddingSize : 0}
    marginBottom={paddingBottom || padding ? paddingSize : 0}
  >
    <Container>
      {title && (
        <Heading as="h2" size="h2" mb={4} textAlign="center">
          {title}
        </Heading>
      )}
      <Flex
        gap={{ base: 1, md: 2 }}
        justifyContent={{ base: links?.length === 1 ? `center` : `flex-start`, sm: `center` }}
        flexWrap={`nowrap`}
        overflow={`auto`}
      >
        {links?.map((item, key) => (
          <Box key={key}>
            <Button as={Link} to={item?.link} variant={variant} whiteSpace={`nowrap`} width={`auto`}>
              {item?.title}
            </Button>
          </Box>
        ))}
      </Flex>
    </Container>
  </Box>
)

export default React.memo(withSection(Links))
